import React from 'react';

export const GoodCannaIcon = ({ width = 79, height = 79 }: { width?: number; height?: number }): JSX.Element => (
  <svg
    data-v-37edb157=''
    width={width}
    height={height}
    viewBox='0 0 79 79'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='79' height='79' rx='17.0392' fill='#104A52' />
    <rect x='34' y='24' width='12' height='37' fill='#FFFAF9' />
    <rect x='21' y='49' width='13' height='37' transform='rotate(-90 21 49)' fill='#FFFAF9' />
    <path
      d='M39.5302 11C46.4648 16.7658 49.7793 23.8886 49.5199 29.2636C49.4418 30.8835 49.7509 32.5355 49.0226 33.754C48.2943 34.9725 46.5252 35.7576 45.1503 36.4042V25.0503H39.5338H33.9065V36.4077C32.4607 35.7292 30.9153 35.2851 30.187 33.9814C29.5263 32.8019 29.6186 30.8089 29.544 29.2671C29.274 23.8886 32.5957 16.7658 39.5302 11Z'
      fill='url(#paint0_linear_1062_1303)'
    />
    <path
      d='M60.3348 27.5254C60.6972 32.8222 65.4753 38.389 63.6777 47.313C61.6883 57.1997 52.6507 64.0454 39.5454 68.1309C26.4329 64.0454 17.3953 57.1997 15.4023 47.313C13.6118 38.4317 18.3545 32.8755 18.7524 27.5929C18.6529 32.1046 16.9086 37.5542 18.6813 42.2044C19.3918 44.066 20.0917 46.5385 22.5678 47.6398H33.9146V58.9973H39.5418H45.1584V47.6398H56.5158C59.0204 46.5243 59.4822 44.3928 60.1856 42.5029C61.9192 37.8348 60.4058 32.0193 60.3241 27.5218L60.3348 27.5254Z'
      fill='url(#paint1_linear_1062_1303)'
    />
    <path
      d='M33.9103 36.408H22.5635V42.0246V47.6411C13.8989 43.7902 18.606 33.9141 18.7446 27.5942C18.7446 27.5693 18.7446 27.5515 18.7446 27.5267C18.8582 25.9245 18.5634 24.3507 17.5687 22.713C17.5687 22.713 26.2937 22.1233 29.5301 29.2674H29.5478C29.7041 32.5109 31.1571 35.1184 33.9103 36.408Z'
      fill='url(#paint2_linear_1062_1303)'
    />
    <path
      d='M60.3313 27.5262C60.413 32.0237 62.8501 38.3508 61.1164 43.0188C60.413 44.9088 59.0275 46.5287 56.523 47.6442V42.0277V36.4111H45.1655C47.9187 35.1216 49.3824 32.5069 49.5351 29.2705H49.5422C52.7786 22.1299 61.5036 22.7161 61.5036 22.7161C60.5089 24.3538 60.2141 25.9276 60.3349 27.5298H60.3313V27.5262Z'
      fill='url(#paint3_linear_1062_1303)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_1062_1303'
        x1='39.5314'
        y1='7.51208'
        x2='39.5314'
        y2='35.4393'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#B2DF6D' />
        <stop offset='0.3453' stopColor='#63B89D' />
        <stop offset='0.6557' stopColor='#3A988F' />
        <stop offset='1' stopColor='#1E6984' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_1062_1303'
        x1='39.5403'
        y1='36.8852'
        x2='39.5403'
        y2='74.7782'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#B2DF6D' />
        <stop offset='0.3453' stopColor='#63B89D' />
        <stop offset='0.6557' stopColor='#3A988F' />
        <stop offset='1' stopColor='#1E6984' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_1062_1303'
        x1='25.6275'
        y1='21.9866'
        x2='25.6275'
        y2='44.2089'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#B2DF6D' />
        <stop offset='0.3453' stopColor='#63B89D' />
        <stop offset='0.6557' stopColor='#3A988F' />
        <stop offset='1' stopColor='#1E6984' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_1062_1303'
        x1='53.4515'
        y1='21.9861'
        x2='53.4515'
        y2='44.2084'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#B2DF6D' />
        <stop offset='0.3453' stopColor='#63B89D' />
        <stop offset='0.6557' stopColor='#3A988F' />
        <stop offset='1' stopColor='#1E6984' />
      </linearGradient>
    </defs>
  </svg>
);
